import React, { useEffect, useState } from 'react'
import AresNavBar from './../Layout/NavBar/NavBar';
import SideBar from '../Layout/SideBar/SideBar';
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';
import { Spinner, Badge, OverlayTrigger, Tooltip, Row, ProgressBar, InputGroup, Form, Col, Button } from 'react-bootstrap';
import { ModalManager } from 'react-dynamic-modal/lib/Modal';
import DefaultModal from './../Util/Modal';
import moment from 'moment';
import http from './../../services/Api';
import swal from 'sweetalert';
import { downloadReport, fetchReport } from './../../utils/Report';

import JSZip from 'jszip';
import saveAs from 'save-as';


import { AiOutlineCloudDownload, AiOutlineFilePdf, AiOutlineSearch } from 'react-icons/ai'
import { RiLoader4Line } from 'react-icons/ri'
import { IoMdRefresh } from 'react-icons/io'

import UploadExcelForm from './UploadExcelForm';

import './index.css'

function Reports() {

    const [loading, setLoading] = useState(true)
    const [tableData, setTableData] = useState(null)
    const [tableKey, setTableKey] = useState(0);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [selectedData, setSelectedData] = useState([]);
    const [buttonClass, setButtonClass] = useState('hide')
    const [isDownloading, setIsDownloading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [dateInit, setDateInit] = useState(null)
    const [dateEnd, setDateEnd] = useState(null)

    useEffect(() => {
        console.log('reports page!')
        init();
    }, [])


    useEffect(() => {
        console.log(selectedData);
    }, [selectedData])

    async function init() {
        await getData();
    }


    async function getData(params) {
        console.log(params);
        setLoading(true);
        try {
            const response = params != null ? await http.get('/api/reports', { params }) : await http.get('/api/reports');
            const data = response.data;
            const columns = getColumns();
            setTableData({
                data,
                columns
            })
            setLoading(false);
        } catch (e) {
            setLoading(false);
            console.log(e);
        }

    }

    async function downloadSelectedData() {
        setProgress(0);
        setIsDownloading(true);
        const data = selectedData[0];
        const zip = new JSZip();
        let count = 0;
        let added = 0;
        let failed = 0;

        try {
            for (let item of data) {
                if (item.download_url) {
                    try {
                        zip.file(item.file, await fetchReport(item.download_url));
                        added++;
                    } catch (e) {
                        failed++;
                    }
                }
                count++;
                setProgress((count / data.length) * 100)
            }

            if (added === 0) {
                swal("Erro!", "Nenhum dos relatórios selecionados foi encontrado. Por favor, gere novos relatórios para o período", "error");
                return;
            }

            saveAs(await zip.generateAsync({ type: 'blob' }), "relatorios-temperatura-umidade.zip");

            if (failed > 0)
                swal("Atenção!", `${failed} relatório(s) não foram encontrados e ficaram de fora do arquivo. Por favor, gere novos relatórios para o período`, "warning");
        } finally {
            setIsDownloading(false);
        }
    }

    async function download(row) {
        try {
            await downloadReport(row.download_url, row.file);
        } catch (e) {
            swal("Erro!", e.message, "error");
        }
    }

    function onSelectedRowsChange({ selectedRows, selectedCount, allSelected }) {
        // UPDATE WITHOUT RENDER //
        selectedData[0] = selectedRows;

        if (selectedRows.length > 0) {
            setButtonClass('show')
        } else {
            setButtonClass('hide')
        }
    }

    function openGenerateReport() {
        ModalManager.open(<DefaultModal title="Enviar arquivo excel" component={<UploadExcelForm />} onClose={getData} />)
    }

    const search = async () => {
        await getData({ dateInit: dateInit != '' ? dateInit : null, dateEnd: dateEnd != '' ? dateEnd : null });
    }

    const setFilters = ({ value }, stateFunction) => {
        stateFunction(value);
    }


    return (
        <div className="Reports sidenav-margin">
            <AresNavBar />
            <SideBar />
            <div className="content">
                <div className="container-header">
                    <h1>Relatórios</h1>

                    <div className="right">
                        <button className="btn action-button btn-secondary" onClick={search}>
                            <IoMdRefresh /> Atualizar
                        </button>

                        <button className="btn action-button btn-danger" onClick={openGenerateReport}>
                            <AiOutlineFilePdf /> Gerar relatórios
                        </button>

                        <div className={buttonClass}>
                            <button className="btn action-button btn-primary" style={{height: '100%'}} onClick={downloadSelectedData} disabled={isDownloading} >
                                {isDownloading ? (<><RiLoader4Line className="spin" /> Preparando arquivos... </>) : (<><AiOutlineCloudDownload /> Baixar selecionados</>)}
                            </button>
                        </div>

                        <Button onClick={search} variant="default" type="button" >
                            <AiOutlineSearch/> Aplicar filtro(s)
                        </Button>
                    </div>
                </div>

                <div className="container-subheader">
                    <Col md={3}>
                        <label className="SearchLabel">Data/Hora Início</label>
                        <InputGroup>
                            <Form.Control
                                onChange={(e) => setFilters(e.target, setDateInit)}
                                placeholder="Data/Hora Início"
                                type="datetime-local"
                                className="form-input"
                            />
                        </InputGroup>
                    </Col>

                    <Col md={3}>
                        <label className="SearchLabel">Data/Hora Fim  </label>
                        <InputGroup>
                            <Form.Control
                                onChange={(e) => setFilters(e.target, setDateEnd)}
                                placeholder="Data/Hora Início"
                                type="datetime-local"
                                className="form-input"
                            />
                        </InputGroup>
                    </Col>
                </div>

                {isDownloading && <ProgressBar variant="success" now={progress} style={{marginTop: '20px'}} label={`${progress.toFixed(2)}%`} />}
                {loading ? renderLoading() : table()}
            </div>
        </div>
    )


    function table() {
        return (
            <DataTableExtensions
                {...tableData}
                filterPlaceholder="Pesquisar dispositivos"
                print={false}>
                <DataTable
                    key={tableKey}
                    noDataComponent={
                        <span>Nada encontrado...</span>
                    }
                    onSelectedRowsChange={onSelectedRowsChange}
                    selectableRows
                    contextMessage={{
                        singular: 'item',
                        plural: 'itens',
                        message: 'selecionado(s)'
                    }}
                    pagination={true}
                    paginationDefaultPage={page}
                    paginationPerPage={rowsPerPage}
                    onChangePage={(page) => setPage(page)}
                    paginationComponentOptions={{ noRowsPerPage: true }}
                    onChangeRowsPerPage={(rowsPerPage, page) => {
                        setPage(page);
                        setRowsPerPage(rowsPerPage)
                    }}
                />
            </DataTableExtensions>
        );
    }

    function getFiltersColumn(row) {
        if (row.filters?.dateInit) {
            const dateStart = moment(row.filters.dateInit).format('DD/MM/YYYY HH:mm');
            const dateEnd = moment(row.filters.dateEnd).format('DD/MM/YYYY HH:mm');
            return `${dateStart} até ${dateEnd}`
        }


        return row.filters != null ? JSON.stringify(row.filters) : '--';
    }

    function getColumns() {
        return [
            {
                name: 'Nome',
                selector: 'device.name',
                sortable: false,
                width: '12%',
            },
            {
                name: 'Mac',
                selector: 'mac',
                sortable: false,
                width: '12%',
            },
            {
                name: 'Status',
                selector: 'status',
                sortable: false,
                format: row => row.status.name,
                width: '10%',
                cell: (row) => row.status.id == 3 ? <OverlayTrigger
                    key="top"
                    placement="top"
                    overlay={
                        <Tooltip id="tooltip-top">
                            {row.error}
                        </Tooltip>
                    }
                >
                    <Badge bg="secondary" style={{ backgroundColor: row.status.color, color: 'white' }}>{row.status.name}</Badge>
                </OverlayTrigger> : <Badge bg="secondary" style={{ backgroundColor: row.status.color, color: 'white' }}>{row.status.name}</Badge>,
            },
            {
                name: 'Período',
                selector: 'filters',
                width: '20%',
                format: getFiltersColumn,
                sortable: false,
            },
            {
                name: 'Gerado em:',
                selector: 'user',
                format: (row) => row.status.id == 2 ? moment(row.updated_at).format('DD/MM/YYYY HH:mm:ss') : '--'
            },
            {
                name: 'Tipo',
                selector: 'type',
            },
            {
                name: 'Ações',
                cell: (row) =>
                    <Row>
                        {row.download_url != null ? (
                            <button onClick={() => download(row)} className="btn action-button btn-secondary">
                                Baixar relatório
                            </button>
                        ) : (
                            <button disabled className="btn action-button btn-secondary">
                                Baixar relatório
                            </button>
                        )}
                    </Row>
                ,
                width: '20%',
            },
        ];
    }

    function renderLoading() {
        return (
            <div className="center-page">
                <Spinner animation="border" />
            </div>
        )
    }
}

export default Reports;
